import {
  getGluelamMaterials,
  getLvlMaterials,
  getSoftWoodMaterials,
  getSteelMaterials,
} from '@queries'

/**
 * @deprecated use materialQueryFromMaterialTypeV2
 * @param materialType
 * @returns
 */
export const materialQueryFromMaterialType = (materialType: string) => {
  switch (materialType) {
    case 'softwoodMaterial': {
      return getSoftWoodMaterials
    }
    case 'glulamMaterial': {
      return getGluelamMaterials
    }
    case 'lvlMaterial': {
      return getLvlMaterials
    }
    case 'steelMaterial': {
      return getSteelMaterials
    }
    default: {
      return getSoftWoodMaterials
    }
  }
}

export const materialQueryFromMaterialTypeV2 = (materialType: MaterialKind) => {
  switch (materialType) {
    case 'Softwood': {
      return getSoftWoodMaterials
    }
    case 'Glulam': {
      return getGluelamMaterials
    }
    case 'LVL': {
      return getLvlMaterials
    }
    case 'Steel': {
      return getSteelMaterials
    }
    default: {
      throw new Error(`Material kind '${materialType}' not possible`)
    }
  }
}
